import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createSeatingReservationRequest = {};
var _createSeatingReservationResponse = {};
var _deleteSeatingReservationRequest = {};
var _deleteSeatingReservationResponse = {};
var _element = {
    uiProperties: '_elementUiProperties',
    multiRowProperties: '_multiRowProperties',
};
var _elementGroup = { uiProperties: '_elementGroupUiProperties' };
var _elementGroupUiProperties = {
    x: 'google.protobuf.DoubleValue',
    y: 'google.protobuf.DoubleValue',
    width: 'google.protobuf.DoubleValue',
    height: 'google.protobuf.DoubleValue',
    rotationAngle: 'google.protobuf.DoubleValue',
};
var _elementUiProperties = {
    x: 'google.protobuf.DoubleValue',
    y: 'google.protobuf.DoubleValue',
    width: 'google.protobuf.DoubleValue',
    height: 'google.protobuf.DoubleValue',
    rotationAngle: 'google.protobuf.DoubleValue',
};
var _getReservationRequest = {};
var _getReservationResponse = {};
var _getSeatingCategorySummaryRequest = {};
var _getSeatingCategorySummaryResponse = {};
var _getSeatingReservationSummaryRequest = {};
var _getSeatingReservationSummaryResponse = { plan: '_seatingPlan' };
var _multiRowProperties = {
    curveAngleTo: 'google.protobuf.DoubleValue',
    curveAngleFrom: 'google.protobuf.DoubleValue',
    rows: '_rowElement',
};
var _querySeatingReservationRequest = {};
var _querySeatingReservationResponse = {};
var _rowElement = { uiProperties: '_rowElementUiProperties' };
var _rowElementUiProperties = {
    relativeX: 'google.protobuf.DoubleValue',
    width: 'google.protobuf.DoubleValue',
    curveAngleFrom: 'google.protobuf.DoubleValue',
    curveAngleTo: 'google.protobuf.DoubleValue',
};
var _seatingPlan = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    sections: '_section',
    elementGroups: '_elementGroup',
};
var _section = { elements: '_element' };
function resolveComWixpressSeatingSeatingReservationServiceUrl(opts) {
    var domainToMappings = {
        _api_base_domain_: [
            {
                srcPath: '/seating-reservations',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/seating-reservations',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/seating-reservations',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/seating/v1/reservations',
                destPath: '/v1/reservations',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a seating reservation */
export function createSeatingReservation(payload) {
    var _a = serializer(_createSeatingReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSeatingReservationResponse, {}).fromJSON;
    function __createSeatingReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.seating.v1.seating_reservation',
            method: 'POST',
            methodFqn: 'com.wixpress.seating.SeatingReservationService.CreateSeatingReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressSeatingSeatingReservationServiceUrl({
                protoPath: '/v1/reservations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSeatingReservation.fromReq = fromReq;
    __createSeatingReservation.__isAmbassador = true;
    return __createSeatingReservation;
}
/** Returns seating reservation */
export function getReservation(payload) {
    var _a = serializer(_getReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReservationResponse, {}).fromJSON;
    function __getReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.seating.v1.seating_reservation',
            method: 'GET',
            methodFqn: 'com.wixpress.seating.SeatingReservationService.GetReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressSeatingSeatingReservationServiceUrl({
                protoPath: '/v1/reservations/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReservation.fromReq = fromReq;
    __getReservation.__isAmbassador = true;
    return __getReservation;
}
/** Lists seating reservations by query request */
export function querySeatingReservation(payload) {
    var _a = serializer(_querySeatingReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySeatingReservationResponse, {}).fromJSON;
    function __querySeatingReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.seating.v1.seating_reservation',
            method: 'POST',
            methodFqn: 'com.wixpress.seating.SeatingReservationService.QuerySeatingReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressSeatingSeatingReservationServiceUrl({
                protoPath: '/v1/reservations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySeatingReservation.fromReq = fromReq;
    __querySeatingReservation.__isAmbassador = true;
    return __querySeatingReservation;
}
/** Deletes the seating reservation */
export function deleteSeatingReservation(payload) {
    var _a = serializer(_deleteSeatingReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSeatingReservationResponse, {}).fromJSON;
    function __deleteSeatingReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.seating.v1.seating_reservation',
            method: 'DELETE',
            methodFqn: 'com.wixpress.seating.SeatingReservationService.DeleteSeatingReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressSeatingSeatingReservationServiceUrl({
                protoPath: '/v1/reservations/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSeatingReservation.fromReq = fromReq;
    __deleteSeatingReservation.__isAmbassador = true;
    return __deleteSeatingReservation;
}
export function getSeatingCategorySummary(payload) {
    var _a = serializer(_getSeatingCategorySummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSeatingCategorySummaryResponse, {}).fromJSON;
    function __getSeatingCategorySummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.seating.v1.seating_reservation',
            method: 'GET',
            methodFqn: 'com.wixpress.seating.SeatingReservationService.GetSeatingCategorySummary',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressSeatingSeatingReservationServiceUrl({
                protoPath: '/v1/reservations/seating-category-summary',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSeatingCategorySummary.fromReq = fromReq;
    __getSeatingCategorySummary.__isAmbassador = true;
    return __getSeatingCategorySummary;
}
export function getSeatingReservationSummary(payload) {
    var _a = serializer(_getSeatingReservationSummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSeatingReservationSummaryResponse, {
        _element: _element,
        _elementGroup: _elementGroup,
        _elementGroupUiProperties: _elementGroupUiProperties,
        _elementUiProperties: _elementUiProperties,
        _multiRowProperties: _multiRowProperties,
        _rowElement: _rowElement,
        _rowElementUiProperties: _rowElementUiProperties,
        _seatingPlan: _seatingPlan,
        _section: _section,
    }).fromJSON;
    function __getSeatingReservationSummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.seating.v1.seating_reservation',
            method: 'GET',
            methodFqn: 'com.wixpress.seating.SeatingReservationService.GetSeatingReservationSummary',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressSeatingSeatingReservationServiceUrl({
                protoPath: '/v1/reservations/seating-reservation-summary/{externalId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSeatingReservationSummary.fromReq = fromReq;
    __getSeatingReservationSummary.__isAmbassador = true;
    return __getSeatingReservationSummary;
}
//# sourceMappingURL=http.impl.js.map